module.exports = __webpack_public_path__ + "img/smile.5df22c52.svg";